module.exports = __webpack_public_path__ + "static/media/15.3f7f45c8.jpg";